import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
//import LoginForm from './LoginForm';
import {formatErrors} from '../../actions/errors';
import {addFlashMessage, clearFlashMessage, login} from '../../actions/jre';
//import {RouteComponentProps, withRouter} from 'react-router';


class Login extends React.Component<RouteComponentProps<any>>{

    constructor(props) {
        super(props);

        this.state = {
            errors: {},
            resetTrue: false,
            tokenValid : false,
            sectionid :'',
            moduleId :'',
            scheduledId:'',
            scheduledType:'',
            studentId:'',
            studentId1:''
        };
    }


    // componentDidUpdate(prevProps) {
    //     const { match } = this.props;
    //     if(match != null || match != undefined){
    //       console.log(this.props.match.params.moduleId);
    //       console.log(prevProps.match.params.moduleId);
    //       if (this.props.match.params.moduleId == prevProps.match.params.moduleId) {
    //         localStorage.removeItem('contentparams');
    //       }
    //     }
    // }

    /*componentWillMount() {
        const search = window.location.href; // could be '?foo=bar'
        var pathname = new URL(search).pathname;
        var loginparams = pathname.split('/');
        console.log(loginparams);
        console.log(search.indexOf('/view/modules'));
        if(search.indexOf('/view/modules') <= -1 && loginparams != null){
          localStorage.setItem('contentparams',JSON.stringify(loginparams));
        }
    }*/

    componentDidMount(){
        // console.log(this.state.studentId);
        // const {clearFlashMessage, formatErrors} = this.props;
        const search = window.location.href; // could be '?foo=bar'
        var pathname = new URL(search).pathname;
        var loginparams = pathname.split('/');
        // console.log(loginparams);


        if(search.indexOf('/view/modules') <= -1 && loginparams != null){
            localStorage.setItem('contentparams',JSON.stringify(loginparams));
        }
        // window.addEventListener("message", (e) => {
        //   if(localStorage.getItem('recordId') != null){
        //     localStorage.removeItem('recordId');
        //   }else{
        //     var data= e.data; // hare are data sent by other window postMessage method
        //     alert(e.data);
        //     localStorage.setItem('recordId',data);
        //     console.log(data);
        //   }
        // });
        let contentparams = JSON.parse(localStorage.getItem('contentparams'));
        console.log(contentparams);
        localStorage.setItem("stuLang",contentparams[11]);
        // console.log('componentDidMount - login');
        // console.log(contentparams);

        if(search.indexOf('/view/modules') != -1){
            contentparams[1] = loginparams[7];
        }
        return this.props.login(contentparams[5],contentparams[6])    //joyson
        .then(() => {
            clearFlashMessage();
            if(contentparams[5] && contentparams[8]=='')
            {
                // console.log(contentparams);
                this.props.history.push('/view/modules/'+contentparams[2]+'/assignments/'
                +contentparams[3]+'/sections/'+contentparams[1]+'/pages/'+contentparams[7]);
            }
            else
            {
                // console.log('in');
                this.props.history.push('/view/modules/'+contentparams[2]+'/assignments/'
                +contentparams[3]+'/sections/'+contentparams[1]+'/pages/'+contentparams[7]+'/extendid/'+contentparams[8]);
            }
        }).catch((err) =>{
            this.setState({
                errors: err,
                isLoading: false,
            });
        });//end joyson
    }

    // .catch((err) => formatErrors(err).then(err => {
    //     this.setState({
    //         errors: err,
    //         isLoading: false,
    //     });
    // }));//end joyson


    /*componentDidMount(){
      console.log('componentDidMount');
      // console.log(this.state.studentId);
      let contentparams = JSON.parse(localStorage.getItem('contentparams'));
      console.log(contentparams);
      // const {clearFlashMessage, formatErrors} = this.props;
      return this.props.login(contentparams[5],contentparams[6])    //joyson
          .then(() => {
              clearFlashMessage();
              // document.location.href='/view/modules/186/assignments/12345';
              // this.props.history.push('/view/modules/186/assignments/12345/sections/1');
              if(contentparams[5]){
                this.props.history.push('/view/modules/'+contentparams[2]+'/assignments/'
                +contentparams[3]+'/sections/'+contentparams[1]+'/pages/'+contentparams[7]);
              }
              if(contentparams[3]>0){ //joyson
                this.props.history.push('/view/modules/'+contentparams[2]+'/assignments/'
                +contentparams[3]+'/sections/'+contentparams[1]+'/pages/'+contentparams[7]);
              }else{
                console.log(contentparams[2],contentparams[1],contentparams[7]);
                this.props.history.push('/view/modules/'+contentparams[2]+'/sections/'+contentparams[1]
                +'/pages/'+contentparams[7]);
              }
          })
          .catch((err) => formatErrors(err).then(err => {
              this.setState({
                  errors: err,
                  isLoading: false,
              });
          }));//end joyson
    }*/

    // onSubmit(data) {
    //     const {clearFlashMessage, formatErrors} = this.props;
    //     return this.props.login(data)
    //         .then(() => {
    //             // clearFlashMessage();
    //             // document.location.href='/view/modules/186/assignments/12345';
    //             this.props.history.push('/view/modules/186/assignments/12345/sections/1');
    //         })
    //         .catch((err) => formatErrors(err).then(err => {
    //             this.setState({
    //                 errors: err,
    //                 isLoading: false,
    //             });
    //         }));
    // }

    render() {
        //const {errors, isLoading} = this.state;
        return <div></div>;
    }

}

Login.propTypes = {
    login: PropTypes.func.isRequired,
    formatErrors: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
      return {
            auth:state.auth
        };
}

const mapDispatchToProps = function (dispatch) {
    return {
        login: (payload) => dispatch(login(payload)),
        clearFlashMessage: () => dispatch(clearFlashMessage()),
        formatErrors: (err) => dispatch(formatErrors(err)),
        addFlashMessage: (message, msgType) => dispatch(addFlashMessage(message, msgType)),

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
export {Login};



// WEBPACK FOOTER //
// ./src/js/components/app/Login.js